var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb-5",attrs:{"color":"primary","dark":"","small":"","left":"","to":"/"}},[_vm._v("Zurück ")])
}
var staticRenderFns = []

export { render, staticRenderFns }